import ForgotPasswordForm from "../../Components/auth/ForgetPasswordForm";
import Header from "../../Components/header/Header";
import "./ForgetPassword.css";

export default function ForgetPassword() {
  return (
    <div className="login-page">

      {/* Top Border */}
      <div className="login-top-border"></div>

      {/* Header */}
      <Header />

      {/* Main Section */}
      <div className="login-main-container">

        {/* Left Image */}
        <div className="login-left-section">
          <img
            src="/mountain.webp"
            alt="Mountain"
            className="login-bg-image"
          />
        </div>

        {/* Right Form */}
        <div className="login-right-section">
          <ForgotPasswordForm />
        </div>

      </div>
    </div>
  );
}